export const BASE_URL = process.env.REACT_APP_DEV_PROXY
// export const BASE_URL = "http://localhost:8001/api/"
export const CALENDY_URL = process.env.REACT_APP_CALENDY_URL
export const ZENDESK_KEY = "c893a791-cd2c-49fe-8900-394ef2c31595";
